<template>
  <t-button tag="div" class="my_button"  @click="clickHandler" :style="setStyles" :disabled="option.attribute.isLoading" :loading="option.attribute.isLoading">
    <t-checkbox v-if="option.attribute.isShowCheckbox" v-model="option.attribute.isChecked"></t-checkbox>
    {{ cptData.value }}
  </t-button>
  <!-- <div style="" @click="clickHandler" :style="setStyles" class="my_button">
    
  </div> -->
</template>

<script>
import {
  getDataJson,
  pollingRefresh,
  hasNonEmptyValues,
  hasProperty,
} from "@/utils/refresh-cpt-data";
import {
  LoginArrId,
} from "@/utils/func";
import { FuncEvents, Login } from '@/utils/functionEvent'
import { MessagePlugin, DialogPlugin } from 'tdesign-vue-next';
import { getResByDatasetIdApi } from "@/api/dataset/dataset";
export default {
  name: "cpt-button",
  props: {
    option: Object,
    height: Number,
    current: Object,
    cacheComponents: Array,
    components: Array,
    refMap: Object
  },
  data() {
    return {
      cptData: {},
      visible: false,
      uuid: null,
      newData: "",
      jsFunFlag: false,
    }
  },
  computed: {
    setStyles() {
      return {
        "--bgColor": this.option.attribute.bgColor,
        "--textColor": this.option.attribute.textColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",
        "--borderSize": this.option.attribute.borderSize + "px",
        "--borderColor": this.option.attribute.borderColor,
        "--borderTopLeftRadius": this.option.attribute.borderTopLeftRadius + "px",
        "--borderBottomLeftRadius": this.option.attribute.borderBottomLeftRadius + "px",
        "--borderTopRightRadius": this.option.attribute.borderTopRightRadius + "px",
        "--borderBottomRightRadius": this.option.attribute.borderBottomRightRadius + "px",
        "--lineType": this.option.attribute.lineType,
        "--lineHeight": this.height + "px",
        "--hoverBgColor": this.option.attribute.hoverBgColor,
      };
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    }
  },
  watch: {
    // "option.attribute": {
    //   handler() {
    //     this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
    //   },
    //   deep: true,
    // },
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  created() {
    this.uuid = require('uuid').v1();
    if (!this.option.attribute.cptTableData) {
      this.option.attribute.cptTableData = [{ "name": "值", "value": "", "namekey": "value" }];
    }

    if (this.option.attribute.borderRadius) {
      this.option.attribute.borderTopLeftRadius = this.option.attribute.borderRadius;
      this.option.attribute.borderTopRightRadius = this.option.attribute.borderRadius;
      this.option.attribute.borderBottomLeftRadius = this.option.attribute.borderRadius;
      this.option.attribute.borderBottomRightRadius = this.option.attribute.borderRadius;
    }

    if (!this.option.attribute.isShowCheckbox) {
      this.option.attribute.isShowCheckbox = 0;
    }
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }

    if (!this.option.cptDataForm.hasOwnProperty('isCache')) {
      this.option.cptDataForm['isCache'] = false
    }
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      console.log('refreshCptData-btn');
      pollingRefresh(this.uuid, cptDataForm, () => this.loadData(cptDataForm, paras))
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        // this.cptData = res;
        that.newData =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.resStr
            : res; //相同数据集只调用一次接口原因
        that.jsFunFlag =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.jsFunction
            : false; //相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag);
      })
    },
    processData(cptDataForm, res, jsFunFlag, isFromGrid) {
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == "4") {
        if (this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid') return

        // 第二层判断 ，如果没有配转换脚本
        if (jsFunFlag) {
          //判断此控件在九宫格里面就不请求数据
          // 没有全部配置映射字段
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            let newres = [];
            let newObj = { ...res[0] };
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            newres.push(newObj);
            this.cptData = newres[0];
          }
        } else {
          // 如果配置了转换脚本
          this.cptData = res;
        }
      } else {
        // 不是数据集类型，是静态数据
        this.cptData = this.newData;
      }
    },
    clickHandler(event) {
      if (this.option.attribute.isShowCheckbox) {
        this.option.attribute.isChecked = !this.option.attribute.isChecked
      }
      if(this.option.attribute.isLoading)return;
      if (LoginArrId.includes(this.current.id)) {//需要登录,需要用户地址
        console.log('检查用户是否登录')
        let isLogin = FuncEvents.getUserId()
        if (!isLogin) {
          return
        }
        console.log('已经登录')


        // MessagePlugin.warning('暂无地址，请新增默认地址');
        getResByDatasetIdApi('aa1f903fe35b194dbdfe725256ef27bb', 'sql', { userId: isLogin }).then(res => {
          if (res.code == 200) {

            const result = JSON.parse(res.data.apiRes)
            if (result.length > 0) {
              console.log('有默认收货地址')
              this.$emit("clickHandler", this.option.interaction, {
                default: 'default',
                event: event,
                current: this.current,
              },
                this.cptData.value,
                'cpt-button', '', this.current)
            } else {
              console.log('没有默认收货地址')
              const confirmDia = DialogPlugin.confirm({
                header: "提示",
                body: `请添加收获地址`,
                className: 't-dialog-wx-white',
                placement: 'center',
                confirmBtn: "确定",
                cancelBtn: "取消",
                onConfirm: () => {
                  confirmDia.destroy();
                  Login.goToWXPage({ url: '/pages/xd-yytPage/childrenDpPage/dp_index_2?url=https://www.xdwater365.com:6883/v/1d3541dd954f79af15fc0e832e152e83' })
                },
                onClose: () => {
                  confirmDia.hide();
                },
              });
            }
          }
        })


      } else {
        this.$emit("clickHandler", this.option.interaction, {
          default: 'default',
          event: event,
          current: this.current,
        },
          this.cptData.value,
          'cpt-button', '', this.current)
      }

    },

  }
}
</script>

<style scoped>
.my_button {
  width: 100%;
  height: 100%;
  text-align: center;
  cursor: pointer;
  background-color: var(--bgColor);
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  line-height: var(--lineHeight);
  border: var(--borderSize) var(--lineType) var(--borderColor);
  border-top-left-radius: var(--borderTopLeftRadius);
  border-bottom-left-radius: var(--borderBottomLeftRadius);
  border-top-right-radius: var(--borderTopRightRadius);
  border-bottom-right-radius: var(--borderBottomRightRadius);
  box-shadow: none;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.my_button /deep/ .t-checkbox__input {
  border-radius: 3px;
  border: 1px solid #dcdcdc;
  background-color: #fff;
}
/* .my_button:hover, .my_button:focus-visible {
    border-color: var(--bgColor);
    background-color: var(--bgColor);
    
} */

.my_button:hover {
  border-color: var(--bgColor);
  background-color: var(--bgColor);
  transform-origin: center center;
  transform: scale(1.1);
}
.my_button::after {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: red;
  width: 100%;
  height: 100%;
}
</style>

<style>
.t-class-dialog-second .t-dialog {
  color: #333 !important;
  background-color: #fff !important;
  border: 1px solid #fff !important;
}

.t-class-dialog-second .t-dialog__header {
  color: #333 !important;
}

.t-class-dialog-second .t-dialog__body {
  color: #333 !important;
}

.t-class-dialog-second .t-button--variant-base.t-button--theme-primary {
  color: #333;
  background-color: #39cd80;
  border-color: #39cd80;
  border-radius: 5px;
}

.t-class-dialog-second .t-button--variant-base.t-button--theme-default {
  color: #333;
  background-color: #f2f2f2;
  border-color: #f2f2f2;
  border-radius: 5px;
}
</style>
